import { render, staticRenderFns } from "./CadastroTerritorioPY.vue?vue&type=template&id=430d197f&lang=pug"
import script from "./CadastroTerritorioPY.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorioPY.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorioPY.vue?vue&type=style&index=0&id=430d197f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports